<app-files-manager class="subpage-content" [folderId]="folderStore.folderId()"></app-files-manager>

<div #dialogFooter></div>
